import React from 'react';
import { History } from 'history';
import BaseView from '../base/base-view.component'; 
import Model from './eventquiz-model';  //editable..
import QuizquestionModel from '../quizquestion/quizquestion-model';
import EventquizCreatePublic from './eventquiz-create-public.component';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowQuizquestion: QuizquestionModel;
}

export default class EventquizView extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowQuizquestion: QuizquestionModel.defaultValue(),
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    private onLoadQuizquestion = (data: any) => {
        this.setState({datarowQuizquestion: data });
    }

    render() {
        return (
            //editable..
            <BaseView history={this.props.history} 
                endPointFilter={Model.endPointFilter} model={Model} onLoad={this.onLoad}>  

                {this.state.datarow.quizquestion > 0 &&
                <BaseView id={this.state.datarow.quizquestion} caption=' ' 
                    model={QuizquestionModel} onLoad={this.onLoadQuizquestion}/>
                }
                {this.state.datarowQuizquestion.id > 0 &&
                <EventquizCreatePublic history={this.props.history} eventId={this.state.datarow.event} datarowQuizquestion={this.state.datarowQuizquestion} readOnly/>
                }
                
            </BaseView>
        );
    }
}